// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.article {
    height:500px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    display: grid;
    place-items: top;
  }
  
  .header {
    font-size: 16px;
    color: white;
    text-align: left;
    font-weight: 500;
  }


  .homepage-row {
    background-color: #F2F2F2 !important;
  }

  .homepage-row  p {
    font-size: small;
  }

  .contact-box {
    margin-top: 3rem;
    background-color: #E5ECF4;
    padding: 1rem;
  }`, "",{"version":3,"sources":["webpack://./src/styles/Homepage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;;EAGA;IACE,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,aAAa;EACf","sourcesContent":[".article {\n    height:500px;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    display: grid;\n    place-items: top;\n  }\n  \n  .header {\n    font-size: 16px;\n    color: white;\n    text-align: left;\n    font-weight: 500;\n  }\n\n\n  .homepage-row {\n    background-color: #F2F2F2 !important;\n  }\n\n  .homepage-row  p {\n    font-size: small;\n  }\n\n  .contact-box {\n    margin-top: 3rem;\n    background-color: #E5ECF4;\n    padding: 1rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
